module.exports = __webpack_public_path__ + "static/media/religion_category.6fb9dd6d.jpg";